import { proxy } from 'valtio';
import { EPSGInfo } from '../common/EPSGInfo';

interface UIState {
  isPotreeMenu: boolean;
}
interface StoreType {
  isLoggedIn: boolean | undefined;
  isInitialized: boolean;
  uiState: UIState;
  activeProjection: null | EPSGInfo
}

const Store: StoreType = proxy({
  isLoggedIn:  undefined,
  isInitialized: false,
  uiState: {
    isPotreeMenu: false
  },
  activeProjection: null
})


export { Store }